import Client from './client';

export default class ServiceFees extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  putFuelAndSurchargesByServiceId(serviceId, options = {}) {
    return this.makeRequest(`${this.host}/internal/ratecard/service/fees/${serviceId}/fuel/surcharges`, {
      ...options,
       method: 'PUT',
    });
  }

}
